module.exports = __webpack_public_path__ + "img/bus-red.1734ccce.svg";